export default __webpack_public_path__ + "4ac0bdf.png";